import type { OneOnOneColleagueItem } from '@/lib/colleagues.ts';
import { m } from '@/paraglide/messages.js';

/* Counts exactly the green rings above it: the colleagues Wundo has a memory of, whatever their settings. */
export function teamMemorySentence(colleagues: readonly OneOnOneColleagueItem[]): string {
  const total = colleagues.length;
  const count = colleagues.filter((colleague) => colleague.memory).length;
  if (count === 0) return m.team_summary_memory_none();
  if (count === total)
    return total === 1
      ? m.team_summary_memory_all_one()
      : m.team_summary_memory_all({ count });

  const rest = total - count;
  return count === 1
    ? m.team_summary_memory_single({ rest })
    : m.team_summary_memory({ count, rest });
}
